<template>
  <el-input
    :value="value"
    v-bind="$attrs"
    :placeholder="placeholder"
    :readonly="readonly"
    @input="inputHandler"
  >
    <slot />
    <rt-portal-icon slot="suffix" color="#CED5EF" name="rt-portal-edit" size="14"></rt-portal-icon>
    <!-- <rt-portal-icon slot="suffix" color="#CED5EF" name="rt-portal-edit" /> -->
  </el-input>
</template>

<script>
export default {
  name: 'RtInput',
  props: {
    placeholder: {
      type: String,
      default: '暂无'
    },
    value: [String, Number],
    datafieldname: String,
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      text: this.value
    };
  },
  methods: {
    inputHandler(newValue) {
      this.$emit('input', newValue, null, this.datafieldname);
    }
  }
};
</script>

<style >
.el-input .rt-icon{
  margin-top: 8px;
}
</style>



// WEBPACK FOOTER //
// rtInput.vue?5c54c295